import PropTypes from 'prop-types';
import { CurrencyPropType } from './currency';

const lineItemPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  legacyBillingCategory: PropTypes.string.isRequired,
  billingCategory: PropTypes.string.isRequired,
  billingSource: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  memo: PropTypes.string.isRequired,
  amount: CurrencyPropType.isRequired,
  carrierBillingCode: PropTypes.string.isRequired,
});

/**
 * @typedef {object} LineItemPropType
 * @property {number} id
 * @property {string} legacyBillingCategory
 * @property {string} billingCategory
 * @property {string} billingSource
 * @property {string} description
 * @property {string} memo
 * @property {CurrencyPropType} amount
 * @property {string} carrierBillingCode
 */

const rateWarningPropType = PropTypes.shape({
  warning: PropTypes.string.isRequired,
});

/**
 * @typedef {object} RateWarningPropType
 * @property {string} warning
 */

const ratePropType = PropTypes.shape({
  shippingCost: CurrencyPropType.isRequired,
  insuranceCost: CurrencyPropType.isRequired,
  confirmationCost: CurrencyPropType.isRequired,
  otherCost: CurrencyPropType.isRequired,
  totalCost: CurrencyPropType.isRequired,
  driverTip: CurrencyPropType.isRequired,
  lineItems: PropTypes.arrayOf(lineItemPropType),
  shipDate: PropTypes.string,
  minEstimatedDeliveryDate: PropTypes.string,
  maxEstimatedDeliveryDate: PropTypes.string,
  estimatedDeliveryByTime: PropTypes.string,
  estimatedDelivery: PropTypes.string,
  estimatedPickup: PropTypes.string,
  rateWarnings: PropTypes.arrayOf(rateWarningPropType).isRequired,
});

/**
 * @typedef {object} RatePropType
 * @property {CurrencyPropType} shippingCost
 * @property {CurrencyPropType} insuranceCost
 * @property {CurrencyPropType} confirmationCost
 * @property {CurrencyPropType} otherCost
 * @property {CurrencyPropType} totalCost
 * @property {CurrencyPropType} driverTip
 * @property {LineItemPropType[]} lineItems
 * @property {string} shipDate
 * @property {string} minEstimatedDeliveryDate
 * @property {string} maxEstimatedDeliveryDate
 * @property {string} estimatedDeliveryByTime
 * @property {string} estimatedDelivery
 * @property {string} estimatedPickup
 * @property {RateWarningPropType[]} rateWarnings
 */

const cheapestOptionPropType = PropTypes.shape({
  rate: ratePropType.isRequired,
  sellerProviderId: PropTypes.number.isRequired,
  shippingServiceId: PropTypes.number.isRequired,
  optionId: PropTypes.string.isRequired,
});

/**
 * @typedef {object} CheapestOptionPropType
 * @property {RatePropType} rate
 * @property {number} sellerProviderId
 * @property {number} shippingServiceId
 * @property {string} optionId
 */

export const BestWayToShipPropType = PropTypes.shape({
  cheapestOption: cheapestOptionPropType,
  exceptionMessages: PropTypes.arrayOf(PropTypes.string),
});

/**
 * @typedef {object} BestWayToShipPropType
 * @property {CheapestOptionPropType} cheapestOption
 * @property {string[]} exceptionMessages
 */
